
var gg;
if(true){
  var WBO_a;
  var wbo_js = true;

 var $wbo_table;
  var wbo_addtocart_text = wbo_addtocart_text;

  var variant_hide_js = "";
  if(typeof variant_hide_text != "undefined"){
    var variant_hide_js = variant_hide_text;  
  }

  var variant_view_js = "";
  if(typeof variant_view_text != "undefined"){
    var variant_hide_js = variant_hide_text;  
  }

  var wbo_max_qty_message_js = "";
  if(typeof wbo_max_qty_message != "undefined"){
    var wbo_max_qty_message_js = wbo_max_qty_message;
  }

  
(function() {
  // Step 1: Load jQuery and leave it global until all scripts load
  var jqScript = document.createElement('script');
  jqScript.src = "https://code.jquery.com/jquery-3.6.0.min.js";
  jqScript.onload = function() {
    // Step 2: Load Bootstrap JS
    var bsScript = document.createElement('script');
    bsScript.src = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js";
    bsScript.onload = function() {
      // Step 3: Load Bootstrap Table JS
      var btScript = document.createElement('script');
      btScript.src = "https://unpkg.com/bootstrap-table@1.22.1/dist/bootstrap-table.min.js";
      btScript.onload = function() {
        // Step 4: Now call noConflict safely
        var WBO_a = jQuery.noConflict(true);
        // Wait for DOM and then init
        WBO_a(function() {
          gg = WBO_a;
          init_wbo(WBO_a);
        });
      };
      document.head.appendChild(btScript);
    };
    document.head.appendChild(bsScript);
  };
  document.head.appendChild(jqScript);
})();
    
          
 

  
 

 function init_wbo(WBO_a){



   WBO_a('#wbo_table').on('post-header.bs.table', function () {
              WBO_a('.bootstrap-table .search input')
                  .removeClass('form-control search-input') // Remove conflicting classes
                  .addClass('wbo-search'); // Add your own class
          });

    WBO_a("#wbo_toolbar_filter:not(.wbo_filter_second) .wbo_filters_list ul li:nth-child(2)").addClass("active");
    
    get_products('',false,1,"title-ascending",false,WBO_a);


    WBO_a(document).on("click", "html", function() {
      WBO_a(".wbo_filter_second").removeClass("wbo_active");
    });

    // hide filter on click outside
    WBO_a(document).on("click", "html", function() {
      WBO_a("#wbo_toolbar_filter").removeClass("wbo_active");
    })
    .on("click", "#wbo_toolbar_filter", function(e){
      e.stopPropagation();
      WBO_a(this).toggleClass("wbo_active");
    })
    .on('click', '#wbo_toolbar_filter .wbo_filters_list', function(e) {
      e.stopPropagation();
    });
    
    // filter function
    WBO_a(document).on("click", "#wbo_toolbar_filter .wbo_filters_list ul li:not(.active):not(.filter_text)", function(e){

      var collection_handle = WBO_a(this).data("collection-handle");

      // add active class for selected collection
      WBO_a(".wbo_filters_list ul li").removeClass("active");
      WBO_a(this).addClass("active");
      WBO_a("#wbo_table").addClass("wbo_hide");

      WBO_a(".wbo_loader").show();
      
      get_products(collection_handle, true,1,"title-ascending",false,WBO_a);
      
    });

    // get variants
    WBO_a(document).on("click", ".wbo_view_variants", function(){

      var th = WBO_a(this);

      var total_variants = th.data('total-variants');
      
      var p_id = th.data('id');
      console.log(p_id);

      if(WBO_a("[data-product-id="+ p_id +"]").parents("tr").is(':visible')){
        
        var button_show_text = variant_view_text.replace(/{COUNT}/gi, total_variants);
            
        th.html(button_show_text);
        
        WBO_a("[data-product-id="+ p_id +"]").parents("tr").hide();  
      }else{
        th.html(variant_hide_text.replace(/{COUNT}/gi, total_variants));
        WBO_a("[data-product-id="+ p_id +"]").parents("tr").show();
      }
      
    })

    WBO_a(document).on("click", ".wbo_logged_out_button", function () {

   window.location.href = "/account";
    });

    // add to cart
    WBO_a(document).on("click", ".wbo_add_to_cart", function () {


      if(is_logged){

       
        
      

          var th = WBO_a(this);
      var parent = th.parents(".wbo_qty_wrapper");
    
          
        
    
        var variant_id = th.data('variant-id');
        

        var parent_quant = th.parents(".wbo_qty");
        var qty = parseInt(parent.find(".wbo_qty_input").val());
    
        var int_max_qty = parseInt(max_qty);
    
        // Check if quantity is valid
        parent.find(".wbo_message").val("").show();
        if (qty > int_max_qty) {
            hide_message(parent, ".wbo_error", 4000);
            parent.find(".wbo_message").html("<p class='wbo_error'>" + wbo_max_qty_message_js.replace(/{QUANTITY}/gi, max_qty) + "</p>");
            return;
        }
    
        if (qty <= 0) {
            hide_message(parent, ".wbo_error", 4000);
            parent.find(".wbo_message").html("<p class='wbo_error'>At least 1 quantity is required</p>");
            return;
        }
    
      //   // Initialize properties object
      //   var properties = {
      //       "_tpo_add_by": "Cypher QOF"
      //   };
    
      //   // Check if "Request Sample" checkbox exists and add it to properties
      //   var requestSampleCheckbox = parent_quant.find("#wbo_request_sample");

      // console.log(requestSampleCheckbox);
      //   if (requestSampleCheckbox.length > 0) {
      //       properties["Request Sample"] = requestSampleCheckbox.is(":checked") ? "Yes" : "No";
      //   }
    
      //   // Check if "Add Pump" checkbox exists and add it to properties
      //   var addPumpCheckbox = parent_quant.find("#wbo_add_pump");
      //   if (addPumpCheckbox.length > 0) {
      //       properties["Add Pump"] = addPumpCheckbox.is(":checked") ? "Yes" : "No";
      //   }
    
        var items = {
            'items': [{
                "id": variant_id,
                "quantity": qty,
              //  "properties": properties
            }]
        };
    
        // Loading state
        var button_html = th.html();
        th.html("<div class='wbo_loader_variant'></div>");
    
        var request = WBO_a.ajax({
            url: "/cart/add.js",
            method: "POST",
            contentType: 'application/json',
            data: JSON.stringify(items),
            dataType: "json",
        });
    
        request.done(function (cart) {
            var previous_cart_total = Number(WBO_a(".wbo_cart_total").data("total-price"));
            var p_price = Number(th.data('price'));
            var qty = th.parents(".wbo_qty_wrapper").find(".wbo_qty_input").val();
            var new_total = ((previous_cart_total + (p_price * qty)) / 100).toFixed(2);
            var format_total_price;
    
            if (dental_shop == "Dental Access") {
                format_total_price = currency_format.replace("{{amount_with_comma_separator}}", new_total);
            } else {
                format_total_price = currency_format.replace("{{amount}}", new_total);
            }
    
            WBO_a(".wbo_cart_total").html(format_total_price).data("total-price", new_total * 100);
    
            WBO_a.getJSON("/cart.js", function (data) {
                WBO_a(".wbo_cart_item_total").html(data.item_count);
                hide_message(parent, ".wbo_success", 4000);
                parent.find(".wbo_message").html("<p class='wbo_success'>" + wbo_addtocart_message.replace('{QUANTITY}', qty).replace('&lcub;QUANTITY&rcub;', qty).replace('<p>', '').replace('</p>', '') + "</p>");
            });
        });
    
        request.fail(function (jqXHR, textStatus, errorThrown) {
            var error_msg = WBO_a.parseJSON(jqXHR.responseText);
            hide_message(parent, ".wbo_error", 4000);
            parent.find(".wbo_message").html("<p class='wbo_error'>" + error_msg.description + "</p>");
        });
    
        request.always(function () {
            WBO_a(th).html("Add more");
        });

      }else{
         window.location.href = "/account";


    
      }
       
    });


    WBO_a(document).on("click", ".wbo_show_more", function(){

      var page_number = WBO_a(this).data("page");
      var is_search = WBO_a("#wbo_page .search-input").val();

      var sort = WBO_a("#wbo_page .wbo_select_options").val();
      if(is_search != ''){
       
        get_products('', true, page_number, sort, is_search,WBO_a);  
      }else{
        get_products('', true, page_number,"title-ascending",false,WBO_a);  
      }
    });

    WBO_a(document).on("change", ".wbo_select_options", function(){
      var sort_val = WBO_a(this).val();
     
      get_products('', true, 1, sort_val,false,WBO_a);  
    });

    WBO_a(document).on("focus", ".search-input", function(event){

      event.preventDefault();
      WBO_a(this).parent().css("width", "100%");
      WBO_a(".float-right").hide();
    });

    WBO_a(document).on("focusout", ".search-input", function(){
      if(WBO_a(this).val() == ""){
        WBO_a(this).parent().css("width", "60%");
        WBO_a(".float-right").show();  
      }
      
    });
  }

  function get_variants(th){
    var product_id = th.data("id");
    
    var tr_index = th.parents("tr").data('index');

    var button_html = th.html();

    th.html("<div class='wbo_loader_variant'></div>");

    // this code is to prevent multiple click
    var me = th;
    if ( me.data('requestRunning') ) {
      return;
    }
    me.data('requestRunning', true);
    
    var request = WBO_a.ajax({
      url: "/apps/wbo",
      method: "POST",
      data: {action: "get_variants", product_id: product_id, is_stock_show: is_stock_show},
      dataType: "json",
      crossDomain: true
    });
  
    request.done(function( data ) {

      if(typeof data.view != "undefined"){

        var v_data = data.view;

        // insert variants
        for (let i = 0; i < v_data.length; i++) {

          var variant_image_src = v_data[i].v_image;
          var product_id = v_data[i].p_id;

          // check if image available, if not, add a placeholder
          if(variant_image_src === ''){
            variant_image_src = placeholder_image;
          }
    
          variant_image = '<img class="wbo_image" src='+ variant_image_src +' alt='+ v_data[i].v_alt +'>'

          var cart_button = "<span data-product-id='"+ product_id +"' data-variant-id='"+ v_data[i].v_id +"' class='button wbo_add_to_cart'>" + wbo_addtocart_text +"</span><p class='wbo_message'></p>";

          var qty_html = "<div class='wbo_qty_wrapper variant_row variant_product_id_"+ product_id +"'><input value="+ min_qty +" class='wbo_qty_input' name='qty' type='number' max='"+ max_qty +"' min='"+ min_qty +"' step='"+ wbo_group +"' >" + cart_button + "</div>" ;

          var v_title = "<a target='_blank' href='/products/"+ v_data[i].p_handle +"?variant="+ v_data[i].v_id +"'>"+ v_data[i].v_title +"</a>"
          
          $wbo_table.bootstrapTable('insertRow', {
            index: ++tr_index,
            row: {
              id: v_data[i].v_id,
              image: variant_image,
              title: v_title,
              sku: v_data[i].v_sku,
              price: v_data[i].v_price,
              stock: v_data[i].v_stock,
              qty: qty_html
            }
          
          });

          //show only clicked variants
          WBO_a(".variant_row").parents(".product-row").hide();
          
          
          var variants_class = WBO_a("#wbo_table").find(".variant_product_id_" + product_id);
          variants_class.parents(".product-row").show();

        }
      }
      
    });

    request.always(function(){
      WBO_a("#wbo_table").find("[data-id="+ product_id +"]").html(button_html);   
      me.data('requestRunning', false);
    })
  
    request.fail(function( jqXHR, textStatus ) {
      console.log( "Request failed: " + textStatus );
    });
  }
  
  function get_products(collection_handle = '', is_second_time = false, page=1, sort_by = "title-ascending", is_search = false, WBO_a) {
        if (collection_handle == '') {
            collection_handle = WBO_a(".wbo_filters_list ul li.active").data("collection-handle");
        }
        
        var me = WBO_a("#wbo_table");
        if (me.data('requestRunning')) {
            return;
        }
        me.data('requestRunning', true);
        
        var ajax_url = is_search
            ? "/search?view=wbo_search_data&type=product&page=" + page + "&q=" + sort_by
            : "/collections/" + collection_handle + "?view=wbo_collection_data&page=" + page + "&sort_by=" + sort_by;
        
        var request = WBO_a.ajax({
            url: ajax_url,
            method: "GET",
            dataType: "json",
            crossDomain: true
        });
        
        request.done(function(server_data) {
            if (typeof server_data.view !== "undefined") {
                WBO_a(".wbo_cart_total").html(server_data.view.total_cart_price_with_currency);
                WBO_a(".wbo_cart_total").data("total-price", server_data.view.total_cart_price);
                
                var data = server_data.view.productItems;
                if (data.length > 1 || server_data.view.totalProductCount == 0) {
                    server_data.view.productItems.splice(-1);
                }
                
                for (let i = 0; i < data.length; i++) {
                    var format_price = data[i]['price'];
                    var product_image = data[i]['image_src'] || placeholder_image;
                    var image_alt = data[i]['image_alt'] || data[i]['title'];
                    var variant_count = data[i]['variant_count'];
                    var variant_name = data[i]['title'] || "";
                    
                      

                    var variant_text = "View {COUNT} Options";
                    var variant_view_text_replace = variant_text.replace(/{COUNT}/gi, variant_count);
                    
                    if (typeof data[i]['discounted_price'] !== "undefined") {
                        format_price = "<s class='wbo_disc_price'>" + format_price + "</s> <span class='wbo_retail_price'>" + data[i]['discounted_price'] + "</span>";
                    }
                    
                    var is_variant = data[i]['product_id'] ? "data-variant-product" : "";
               

                    var cart_button;
                    if(is_logged){
                          cart_button = data[i]['is_available']
                        ? "<span style='background-color:" + add_cart_button_color + "; padding:13px; color:white; cursor: pointer;' data-price=" + data[i]['actual_price'] + " " + is_variant + " data-product-id='" + data[i]['id'] + "' data-variant-id='" + data[i]['variant_id'] + "' class='button wbo_add_to_cart'>" + wbo_addtocart_text + "</span><p class='wbo_message'></p>"
                        : "<span data-price=" + data[i]['actual_price'] + " " + is_variant + " data-product-id='" + data[i]['id'] + "' data-variant-id='" + data[i]['variant_id'] + "' class='button button--secondary wbo_sold_out'>Sold out</span><p class='wbo_message'></p>";
                    }else{
                          cart_button = data[i]['is_available']
                        ? "<span style='background-color:" + add_cart_button_color + "; padding:13px; color:white; cursor: pointer;' data-price=" + data[i]['actual_price'] + " " + is_variant + " data-product-id='" + data[i]['id'] + "' data-variant-id='" + data[i]['variant_id'] + "' class='button wbo_logged_out_button'>Please login to add to cart</span><p class='wbo_message'></p>"
                        : "<span data-price=" + data[i]['actual_price'] + " " + is_variant + " data-product-id='" + data[i]['id'] + "' data-variant-id='" + data[i]['variant_id'] + "' class='button button--secondary wbo_sold_out'>Sold out</span><p class='wbo_message'></p>";
                    }
                    var qty_html = "<div class='wbo_qty_wrapper'><input class='wbo_qty_input' value='1' name='qty' type='number' min='1' step='" + wbo_group + "' >" + cart_button + "</div>";



                  
                    if (variant_count > 1) {
                        qty_html = "<span data-total-variants=" + variant_count + " class='btn button button--secondary wbo_view_variants' data-id='" + data[i]['id'] + "'>" + variant_view_text_replace + "</span>";
                    }
                    
                    // if (variant_name.includes("Retail")) {
                    //     qty_html += " <input type='checkbox' id='wbo_request_sample' style='margin-top:15px;' data-id='" + data[i]['id'] + "'> Request Sample";
                    // } else if (variant_name.includes("Prof.")) {
                    //     qty_html += " <input type='checkbox' id='wbo_add_pump'  style='margin-top:15px;' data-id='" + data[i]['id'] + "'> Add Pump";
                    // }
                    data[i]["stock"] = data[i]['product_vendor'];
                    data[i]['price'] = format_price;
                    data[i]['qty'] = qty_html;
                    data[i]['image'] = "<img class='wbo_image' src='" + product_image + "' alt='" + image_alt + "'>";
                    data[i]['title'] = "<a target='_blank' href='/products/" + data[i]['handle'] + "'>" + data[i]['title'] + "</a>";
                }
                
                WBO_a('#wbo_table').show();
                var $wbo_table = WBO_a('#wbo_table');
                
                if (is_second_time) {
                    if (page > 1) {
                        $wbo_table.bootstrapTable('append', data);
                    } else {
                        $wbo_table.bootstrapTable('load', data);
                    }
                } else {
                    $wbo_table.bootstrapTable({
                        data: data,
                        pagination: false,
                        search: true,
                        customSearch: "customSearch",
                        searchAccentNeutralise: true,
                        // sortName: 'title',
                        // sortOrder: 'asc',
                      
                        toolbar: "#wbo_toolbar, #wbo_toolbar_filter, #wbo_toolbar_sort",
                        searchAlign: "left",
                        toolbarAlign: "right",
                      
                        formatSearch: function() {
                            return placeholdertext;
                        },
                      rowStyle: function(row, index) {
                        if (row.product_id) { // If product_id exists, it's a variant
                            return { 
                                classes: "product-row variant-row", 
                                css: { 
                                    "background-color": "#f0f0f0", 
                                    "padding": "10px", 
                                    "max-width": "80%"  // Adjust width as needed
                                } 
                            };
                        }
                        return { classes: "product-row" };
                    }
                    });
                }

              
             
            }

        if (typeof server_data.view.currentPageNumber !== "undefined") {
                if (server_data.view.totalPages != server_data.view.currentPageNumber) {
                    var next_page = Number(server_data.view.currentPageNumber) + 1;
                    WBO_a(".wbo_show_more").show().data("page", next_page);
                } else {
                    WBO_a(".wbo_show_more").hide();
                }
            }
            
            hide_variants(WBO_a);
        });
        
        request.always(function() {

        

         
            WBO_a(".wbo_loader").hide();
            WBO_a("#wbo_page #wbo_toolbar, #wbo_page #wbo_toolbar_filter, #wbo_toolbar_sort").css("display", "inline-block");
            WBO_a('.wbo_filter_second').insertAfter('#wbo_toolbar_filter');
            WBO_a("#wbo_table").removeClass("wbo_hide");
            WBO_a(".fixed-table-toolbar").addClass("gradient");

         

         
            me.data('requestRunning', false);

            
        });
        
        request.fail(function(jqXHR, textStatus) {
            console.log("Request failed: " + textStatus);
        });
    }



  function hide_variants(WBO_a) {

    WBO_a("[data-variant-product]").each(function(){
      WBO_a(this).parents("tr").hide();
    })
    
  }

  function customSearch(data, text) {
    
    var WBO_a;
    console.log(text);
    var search_text = text + "*";

    if(text == ''){
     
      get_products('', true,1,"title-ascending",false,gg);
    }else{
      get_products('', true, 1, search_text,true,gg);  
    }
    
    return data.filter(function (row) {
      return true;
    })
      
  }

  function hide_message(parent,target, time) {
    setTimeout(function(){
      parent.find(target).hide();
    }, time);
  }

if(typeof activate_price_change_js != "undefined"){
  document.addEventListener('DOMContentLoaded', () => {

  setTimeout(function () {
 //   document.querySelectorAll('.spf-product-card').forEach(updatePriceInCard);
  }, 1000);

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('.spf-product__swatch');
      if (swatch) {
        const card = swatch.closest('.spf-product-card');
        if (card) {
         // setTimeout(() => updatePriceInCard(card), 50);
        }
      }
    });

  (function monitorScriptLoad() {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        if (
          node.tagName === 'SCRIPT' &&
          node.src &&
          node.src.includes('filter-v3.globo.io/api/apiFilter')
        ) {
          node.addEventListener('load', () => {
            setTimeout(() => {
            //  document.querySelectorAll('.spf-product-card').forEach(updatePriceInCard);
            }, 100);
          });
        }
      }
    }
  });

  observer.observe(document.head, { childList: true });
})();

   
  });
  
}

// function updatePriceInCard(cardElement) {
//     const priceElement = cardElement.querySelector('.spf-product-card__price');
//     if (!priceElement) return;

//     const span = priceElement.querySelector('span');
//     const priceText = span ? span.textContent : priceElement.textContent;

//     const originalPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
//     if (isNaN(originalPrice)) return;

//     const discountedPrice = (originalPrice * (1 - total_discount / 100)).toFixed(2);
//     const formattedOriginal = `$${originalPrice.toFixed(2)}`;
//     const formattedDiscounted = `$${discountedPrice}`;

//     priceElement.innerHTML = `<s style="color:gray;">${formattedOriginal}</s> <span>${formattedDiscounted}</span>`;
// }
  
  
}

